<template>
  <Transition
    name="modalPopupLive"
    id="modalPopupLive"
  >
    <div v-if="props.optionsLivePopup.showModal" class="">
      <div class="modal-container-footer">
        <div class="modal-header-footer">
          <button class="close-black" @click="closeModalLive()">
            <img
              src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
              alt="Close"
              class="close-modal"
            />
          </button>
        </div>
        <div class="modal-body-footer">
          <a @click="goLink('/pt-br/live')">
            <img
              :src="props.optionsLivePopup.imageBanner"
              alt="Live Banner"
              title="Live banner"
              :width="isMobile() ? 391 : 1230"
              :height="isMobile() ? 48 : 150"
            />
          </a>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { isMobile } from "@/shared/utils/mobile";

const props = defineProps({
  optionsLivePopup: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update:optionsLivePopup']);

function goLink(link: string) {
  window.location.href = link;
}

function closeModalLive() {
  emit('update:optionsLivePopup', {
    ...props.optionsLivePopup,
    showModal: false
  });  
  sessionStorage.setItem(
    "inLiveBannerClosed",
    JSON.stringify(true)
  );

}

</script>

<style scoped>
.modal-mask-footer {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}

.modal-container-footer {
  z-index: 9999;
  padding: 0px 0px;
  border-radius: 0px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  opacity: 0.7;
  position: fixed;
  bottom: 50px;
  left: 50%;
  transform: translate(-50%);
  cursor: pointer;
}
.modal-header,
.modal-header-footer {
  display: block;
  text-align: center;
}

.modal-body,
.modal-body-footer {
  margin: 0;
  padding: 0px 0px;
}

.modal-default-button {
  float: right;
}

/*
* The following styles are auto-applied to elements with
* transition="modal" when their visibility is toggled
* by Vue.js.
*
* You can easily play with the modal transition by editing
* these styles.
*/

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.close-modal {
  width: 25px;
  height: 25px;
  margin: 3px;
}

.close-black, .close-black-video {
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 1;
}



:deep(.modal-body-footer img) {
  width: 100%;
}

.modal-body video{
  max-width: 700px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .modal-container,
  .modal-container-footer {
    width: 95%;
    bottom: 20px; 
  }

  .modal-body video{
    max-width: 90%;
    left: 50%;
    transform: translate(-50%);    
  }

  :deep(.modal-body-footer img) {
    width: 100%;
    height: auto;
  }

  .close-modal {
    width: 20px;
    height: 20px;
    margin: 3px;
  }

  .close-black-video {
    right: 5%;
    top: 0px;
  }
}
</style>
